// extracted by mini-css-extract-plugin
export var alignCenter = "_9n-d";
export var bannerShown = "_9n-6";
export var buttonContent = "_9n-0";
export var cardList = "_9n-1";
export var centerContent = "_9n-2";
export var chevron = "_9n-3";
export var closePanelButton = "_9n-k";
export var conversationContextContainer = "_9n-l";
export var conversationDetailContainer = "_9n-4";
export var detailWrapper = "_9n-7";
export var dropdownButton = "_9n-e";
export var dropdownTitle = "_9n-9";
export var fullHeight = "_9n-5";
export var hidden = "_9n-a";
export var icon = "_9n-b";
export var mergeSuggestionWrapper = "_9n-m";
export var panel = "_9n-i";
export var portalButtonsWrapper = "_9n-c";
export var right = "_9n-j";
export var tableSummaryContainer = "_9n-8";
export var tableSummaryHeader = "_9n-g";
export var threeDotsButton = "_9n-f";
export var wide = "_9n-h";